import React from "react";
import ReactDOM from "react-dom/client";
// App.css は Tailwind のディレクティブと全体の土台を持つ。
// 各画面の CSS より必ず先に読み込ませ、画面側が上書きできる状態にする。
import "./App.css";
import "./styles/tokens.css";
import "./index.css";
import "./styles/admin-table.css";
import "./styles/theme-dark.css";
import App from "./App.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
